// Note: This file is related to an issue with WEBVIEW and electron interactions.
// On initial log or sub subsequent loads, electron unloads the plug-in, which causes
// the webview to crash. It is a known issue and this is a work around found at the link below:
// Article: https://github.com/electron/electron/issues/10176

const originalRemoveEventListener = window.removeEventListener;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function removeEventListenerOverloaded(this: any, eventName: string, listener?: EventListenerOrEventListenerObject): any {
  if (listener && needToCallOriginalMethod(eventName, listener.toString())) {
    // calling native/original implementation
    // eslint-disable-next-line prefer-rest-params
    return originalRemoveEventListener.apply(this, arguments);
  } else {
    // calling implementation patched by Zone.js
    // eslint-disable-next-line prefer-rest-params
    return EventTarget.prototype.removeEventListener.apply(this, arguments);
  }
}

function needToCallOriginalMethod(eventName: string, listenerFunctionStringified: string,
): boolean {
  return eventName === 'readystatechange'
    && listenerFunctionStringified.indexOf('registerBrowserPluginElement()') !== -1
    && listenerFunctionStringified.indexOf('registerWebViewElement()') !== -1;
}

window.removeEventListener = removeEventListenerOverloaded;
